document.addEventListener('DOMContentLoaded', function () {
  window.pdp_abtest_one = false;
  setTimeout(function () {
    if (window.pdp_abtest_one) {
      document.body.setAttribute('ab-test-pdp-one', 1);
    }
  }, 1500);
});